import { useState, useEffect } from 'react'

import { Drawer } from 'antd'
import { useSelector } from 'react-redux'

import { getContactPersonSpecialitiesByInstitution } from '../../utils/api/users'
import SmartTable, { SmartTableDataTypes } from './SmartTable'
import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'
import { selectUser } from '../../reducers/UserReducer'

const ContactPersonSpecialitiesInstitutionWidget = props => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const [contactPersonSpecialityYears, setContactPersonSpecialityYears] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (props.user !== null && user !== null) {
      getContactPersonSpecialitiesByInstitution(props.user, props.institution, user).then(data => {
        data.map(specialityYear => {
          specialityYear.name = specialityYear.specialityAbbreviation + ' (' + specialityYear.studyYearName + ')'
        })

        setContactPersonSpecialityYears(data)
        setLoading(false)
      })
    }
  }, [props.user, user])

  const COLUMNS = [
    {
      type: SmartTableDataTypes.STRING,
      name: t('Specialities'),
      key: 'name'
    }
  ]

  return (
    <Drawer
      title={props.user !== null ? t('Specialities managed by') + ' ' + props.user.email : '?'}
      width='640px'
      onClose={props.onClose}
      visible={props.user !== null}
    >
      <SmartTable
        loading={loading}
        columns={COLUMNS}
        data={contactPersonSpecialityYears}
        noDataText={t('Without speciality')}
      />
    </Drawer>
  )
}

export default ContactPersonSpecialitiesInstitutionWidget
